import { ToastrService } from 'ngx-toastr';
import { ForgetPasswordDialogComponent } from '../forget-password-dialog/forget-password-dialog.component';
import { AccountService } from '../../../@resources/services/account.service';
import { AuthService } from '../../../@resources/services/auth.service';
import { Global } from '../../../@core/global/global';
import { Component, OnInit, Output, EventEmitter } from '@angular/core';
import { FormBuilder, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { LocalStorageService } from '../../../@resources/services/local-storage.service';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { CartService } from 'src/app/@shared/services/cart/cart.service';

@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.scss'],
})
export class LoginComponent implements OnInit {
  isSubmitting = false;
  @Output() changeLogin: EventEmitter<string> = new EventEmitter();
  logInForm = this.fb.group({
    login: ['', [Validators.required]],
    password: ['', [Validators.required]],
  });

  constructor(
    private fb: FormBuilder,
    private authService: AuthService,
    private localStorage: LocalStorageService,
    private router: Router,
    public global: Global,
    public dialogRef: MatDialogRef<LoginComponent>,
    public accountService: AccountService,
    public dialog: MatDialog,
    public toastrService: ToastrService,
    private cartService: CartService
  ) {}

  ngOnInit(): void {}

  logIn(): void {
    const lang = this.localStorage.get('lang');
    const obj = {
      email: this.logInForm.value.login,
      password: this.logInForm.value.password,
    };
    this.isSubmitting = true;
    this.authService.gLogIn(obj).subscribe(
      ({ data }) => {
        this.isSubmitting = false;
        // if (data.result === false) {
        //   this.toastrService.error(`${data?.msg}`, ``);
        // } else {
        //   this.global.authenticated = true;
        //   this.localStorage.set('TOKEN', data?.data?.user_id);
        //   this.global.customer = data?.data;
        //   this.localStorage.set('CUSTOMER', data?.data);
        //   this.toastrService.success(`Customer Login Successfully`, `Login`);
        //   this.dialogRef.close();
        //   // this.router.navigate(['/account']);
        // }
        // this.localStorage.set('TOKEN', data?.signIn?.accessToken);
        // this.global.authenticated =  true;
        // this.customer();
        // this.dialogRef.close();
        // this.toastrService.success(`Customer Login Successfully`, `Login`);
        // this.router.navigate(['/account']);
        if (!data.signIn.cartId) {
          const cart = this.cartService.createCart(data.signIn.customerId);
          console.log(cart);
        } else {
          localStorage.setItem('amandaCartId', data.signIn.cartId);
        }
        this.localStorage.set('TOKEN', data?.signIn?.accessToken);
        this.global.authenticated = true;
        this.global.customer = data?.signIn;
        this.localStorage.set('CUSTOMER', data?.signIn);
        this.cartService.migrateClientCartWithLoginCart();
        this.localStorage.remove('amandaClientCartId');
        this.customer();
        this.dialogRef.close();
        lang == 'en'
          ? this.toastrService.success(`Customer Login Successfully`, `Login`)
          : this.toastrService.success(`تم تسجيل الدخول بنجاح`, `تسجيل الدخول`);
        this.router.navigate(['/']);
      },
      (error) => {
        lang == 'en'
          ? this.toastrService.error(error, `Login`)
          : this.toastrService.error(error, `تسجيل الدخول `);
        this.isSubmitting = false;
      }
    );
  }

  public get login() {
    return this.logInForm.get('login');
  }

  public get password() {
    return this.logInForm.get('password');
  }

  customer(): void {
    this.accountService.listCustomer().subscribe(({ data }) => {
      this.global.customer = data?.customer;
      this.localStorage.set('CUSTOMER', data?.customer);
    });
  }

  navigateSignup(): void {
    this.changeLogin.emit('signUp');
  }

  navigateForget(): void {
    this.dialogRef.close();
    const dialogRef = this.dialog.open(ForgetPasswordDialogComponent, {
      autoFocus: false,
    });
  }
}
